<template>
  <div class="home">
    jump
  </div>
</template>

<script>

export default {
  name: 'jumpPage',
  data () {
    return {}
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      this.$router.push('/Home?nfcConfig=000006&jump=1')
      // window.location.href = 'https://wxaurl.cn/aB8eP4nBHDt'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.home {
  height: 100%;
  //overflow-y: auto; /* 仅在容器内允许滚动 */
  overflow: hidden;
  -webkit-overflow-scrolling: touch; /* 启用弹性滚动 */
}

.home {
  min-height: 100vh;
  background-color: white;
}

.status-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 44px;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: $white;
  z-index: 100;
}

.banner {
  position: relative;

  .banner-content {
    position: absolute;
    top: 44px; // 状态栏高度
    left: 26px; // 左边距26px
    z-index: 2;

    .title {
      font-size: 20px;
      font-weight: bold;
      color: $white;
      margin-bottom: 4px;
    }

    .subtitle {
      font-size: 12px;
      color: rgba($white, 0.8);
      max-width: 209px; // 设置最大宽度
      line-height: 1.4; // 适当的行高
      word-wrap: break-word; // 确保长单词也会换行
      text-transform: uppercase; // 确保全大写
    }
  }

  .banner-img {
    width: 100%;
    display: block;
  }
}

.card {
  padding: 16px;
  background: $white;
  border-radius: $border-radius-large;
  position: relative;

  .title-container {
    position: relative;
    background: transparent; /* 关键：确保父容器背景透明 */
    margin-bottom: 16px;
  }

  .title-container::before {
    content: "";
    position: absolute;
    left: 12%;
    bottom: 0;
    transform: translateX(-50%); /* 水平居中 */
    width: 260px; /* 根据实际图片宽度调整 */
    height: 12px; /* 根据实际图片高度调整 */
    background: url(../assets/images/title_bg_2x.png) no-repeat center; /* 替换为你的背景图路径 */
    background-size: contain; /* 保持图片比例 */
    z-index: 0; /* 调整为0 */
  }

  .section-title {
    font-size: $font-size-xlarge;
    color: $text-color;
    position: relative;
    z-index: 1; /* 提升文字层级 */
    font-weight: bold;
  }
}

.wechat-section {
  .wechat-button {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10px 10px; // 调整内边距
    background-image: url("@/assets/images/wechat_bg_all.png");
    background-size: 100% auto;
    background-repeat: no-repeat;
    height: 140px;
    display: flex;
    color: $white;

    .wechat-button-top {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin-bottom: 30px;

      .wechat-icon {
        width: 44px;
        height: 45px;
        margin-right: 6px;
        display: block; // 确保图标正确显示
        flex-shrink: 0; // 防止图标被压缩
        //margin-left: 81px;
      }

      .wechat-font {
        font-size: 20px;
        font-weight: bold;
        color: #37838C;
        line-height: 20px;
        display: inline-block;
      }
    }

    .service-hint {
      width: 100%;
      position: absolute;
      bottom: 28px;
      left: 28px;
      display: flex;
      margin-top: 50px;

      img {
        width: 15px;
        height: 15px;
      }

      .hint-text {
        margin-left: 3px;
        color: rgba(56, 159, 171, 1);
        font-size: 12px;
      }
    }
  }
}

.social-section {
  .social-list {
    display: flex;
    justify-content: space-between;
    padding: 0 20px;

    // 当只有两个元素时的特殊样式
    &.two-items {
      justify-content: center; // 居中对齐
      gap: 80px; // 设置两个元素之间的间距
      // 或者使用具体的像素值
      // gap: 80px; // 可以根据需要调整这个值
    }
  }

  .social-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;

    img {
      width: 88px;
      height: 88px;
      border-radius: $border-radius-base;
    }

    span {
      font-size: $font-size-base;
      color: $text-color;
      font-weight: bold;
    }
  }
}
</style>
